import dynamic from 'next/dynamic';

export default dynamic(() => import('./StaticDateTimePickerInternal'), { ssr: false });
